import { GraphQLWsLink } from '@apollo/client/link/subscriptions'
import { createClient } from 'graphql-ws'

import Config from '@/config/config'
import { getAdditionalHeaders } from '@/network/common/additionalHeaders'
import { getCookie } from '@/providers/authentication/authentication.helpers'
import { MAX_TIME_BEFORE_RETRY } from '@/providers/NetworkGateway.provider'

const computeProgressiveRetryTimeout = (retries: number) => {
  if (retries < 50) {
    return 500
  } else {
    // Each 50 retries, we add 500ms to the timeout, we cap it at MAX_TIME_BEFORE_RETRY
    const nbOf50Retries = Math.floor(retries / 50) - 1
    const timeToAdd = nbOf50Retries * 500
    return Math.min(timeToAdd, MAX_TIME_BEFORE_RETRY)
  }
}

/**
 * @private only to be used in apolloClient.ts
 */
export const getWebsocketLink = (setNextTimeBeforeRetry: (time: number) => void) => {
  const wsClient = createClient({
    url: `${Config.SOCKET_URL}/graphql`,
    connectionParams: async () => {
      const additionalHeaders = await getAdditionalHeaders()
      const token = getCookie('token')
      if (token) return { ...additionalHeaders, authorization: token }

      return additionalHeaders
    },
    shouldRetry: () => {
      return true
    },
    retryAttempts: Infinity,
    retryWait: (retries) => {
      const nextTimeout = computeProgressiveRetryTimeout(retries)
      setNextTimeBeforeRetry(nextTimeout)
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, nextTimeout)
      })
    },
    keepAlive: 5_000,
  })

  window.__VOGGT__WS_CLIENT__ = wsClient

  return new GraphQLWsLink(wsClient)
}
